import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'

import { deepGet } from '../../shared/utils'
import ListEntry from './ListEntry'

@inject('auth')
@observer
export default
class List extends Component {

  static propTypes = {
    auth: PropTypes.object,
    filter: PropTypes.object,
    guidedTour: PropTypes.object,
  }

  render() {

    const { guidedTour, auth, filter } = this.props

    const list = guidedTour.collection
      .filter((currGuidedTour) => {
        if (!filter) {
          return true
        }
        return Object.keys(filter).reduce((memo, key) => {
          return memo && currGuidedTour[key] === filter[key]
        }, true)
      })

    const currentUserMuseum = deepGet(auth, 'user.museumId')

    return (
      <ul
        className="nav-list"
      >
        {
          (list || [])
            .filter((currGuidedTour) => currGuidedTour.museum.id === currentUserMuseum)
            .map((currGuidedTour) => (
              <ListEntry
                editable={currGuidedTour.museum.id === currentUserMuseum}
                key={currGuidedTour.id}
                guidedTour={currGuidedTour}
              />
            ))
        }

      </ul>
    )
  }

}



// WEBPACK FOOTER //
// ./src/guided-tour/components/SimpleList.js